import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../createApiConfig';

export const cMCampaignsApi = createApi({
  reducerPath: 'cMCampaignsApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['Campaigns'],
  endpoints: (builder) => ({
    getCampaigns: builder.query({
      query: (params) => ({
        url: `/campaigns/`,
        params,
      }),
      providesTags: ['Campaigns'],
    }),
    getCampaignById: builder.query({
      query: ({id, ...params}) => ({
        url: `/campaigns/${id}/`,
        params,
      }),
      providesTags: ['Campaigns'],
    }),
    createCampaign: builder.mutation({
      query: (body) => ({
        url: '/campaigns/',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Campaigns'],
    }),
    updateCampaign: builder.mutation({
      query: ({ id, body }) => ({
        url: `/campaigns/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Campaigns'],
    }),
    deleteCampaign: builder.mutation({
      query: (id) => ({
        url: `/campaigns/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Campaigns'],
    }),
    getCampaignInfo: builder.query({
      query: (params) => ({
        url: '/campaigns/campaign-info/',
        params,
      }),
    }),
  }),
});

export const {
  useGetCampaignsQuery,
  useLazyGetCampaignsQuery,
  useGetCampaignByIdQuery,
  useGetCampaignInfoQuery,
  useLazyGetCampaignInfoQuery,
  useCreateCampaignMutation,
  useUpdateCampaignMutation,
  useDeleteCampaignMutation,
} = cMCampaignsApi;